<template>
  <container>
    <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">
      <SubpageGallery
        gallery-class="mt-0"
        v-if="universityDetails && universityDetails.images.length > 0"
        :gallery="universityDetails.images"
        :img-count="universityDetails.images.length > 5 ? 5 : 3"
      />

      <div class="subpage-text text-left" v-if="universityDetails" v-html="universityDetails.content"></div>
    </div>
  </container>
</template>

<script>
import SubpageGallery from '@/components/SubpageGallery'
import { mapGetters } from 'vuex'
export default {
  name: 'UniDetailAbout',
  components: {
    SubpageGallery
  },
  data () {
    return {
      gallery: [
        {
          id: 0,
          img: require('@/assets/img/sehir-galeri/5.jpg')
        },
        {
          id: 1,
          img: require('@/assets/img/sehir-galeri/1.jpg')
        },
        {
          id: 2,
          img: require('@/assets/img/sehir-galeri/2.jpg')
        },
        {
          id: 3,
          img: require('@/assets/img/sehir-galeri/3.jpg')
        },
        {
          id: 4,
          img: require('@/assets/img/sehir-galeri/4.jpg')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['universityDetails'])
  }
}
</script>

<style scoped>

</style>
